<template>
    <span class="base">
        <v-progress-circular :size="mySize" :width="width" :color="color" :value="valor"/>
        <span class="primary--text font-weight-bold posicionar" :class="esMovil ? 'movil' : 'normal'">
            {{ this.putuacionVista }}
        </span>
    </span>
</template>

<script>
    export default {
        name: 'PuntuacionSolucionConstructiva',
        components: {},
        props: {
            puntuacion: {
                type: [Number],
                required: true
            },
            color: [String],
            size: [String]
        },
        data: () => ({
            valor: 0
        }),
        mounted: function () {
            if (typeof this.puntuacion != "undefined")
                this.valor = 10 * this.puntuacion;
        },
        computed: {
            putuacionVista: function () {
                if (typeof this.puntuacion == "undefined") return "0.0";
                let redondeado = Math.round(this.puntuacion * 10) / 10;

                return redondeado.toFixed(1);
            },
            mySize: function () {
                if (typeof this.size == "undefined") return "80";
                return this.size;
            },
            width: function () {
                if (typeof this.size == "undefined") return "12";
                return (this.size * 12) / 80;
            },
            esMovil() {
                return this.$vuetify.breakpoint.smAndDown;
            }
        },
        watch: {
            puntuacion: function (val) {
                this.valor = 10 * val;
            }
        },

    };
</script>

<style lang="scss" scoped>
    .base {
        position: relative;
        width: 80px;
        max-width: 80px;
        min-width: 80px;
        height: 80px;

    }

    .posicionar {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .posicionar.normal {
        font-size: 24px;
    }

    .posicionar.movil {
        font-size: 16px;
    }
</style>
